module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/reports/pto-4f3323.png";